import { MainInner, MainSection, StyledMainSection } from "@/styles/global";
import {
  Body,
  DisplayHeadingS,
  DisplayHeadingSCss,
  TypographyProps,
} from "@/styles/typography";
import styled from "styled-components";

const Section = styled(StyledMainSection)``;

const Inner = styled(MainInner)`
  display: flex;
  width: 100%;
`;

const CounterContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: center;
  border: 5px solid ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.creme};
  border-radius: 10px;
  gap: 16px;
  margin: 0 auto;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 40px;
    width: 60%;
    min-width: 600px;
    margin: 0 auto;
    gap: 32px;
  }
`;

const Title = styled.h2<TypographyProps>`
  ${DisplayHeadingSCss}
  font-size: 32px;
`;

const Counter = styled.div`
  display: flex;
  width: 100%;

  justify-content: center;
  padding: 8px 24px;
  border: 1px solid ${({ theme }) => theme.colors.black};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 80%;
  }
`;

const CounterValue = styled(Body)`
  ${DisplayHeadingSCss}
  font-size: 24px;
  color: ${({ theme }) => theme.colors.black};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 32px;
  }
`;

const SmallText = styled(Body)`
  color: ${({ theme }) => theme.colors.black};
  font-size: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 20px;
  }
`;

const S = {
  Section,
  Inner,
  CounterContainer,
  Title,
  Counter,
  CounterValue,
  SmallText,
};

export default S;
